#import "./user-fragment.graphql"
#import "./origin-fragment.graphql"
#import "./contact-fragment.graphql"
#import "./note-fragment.graphql"
#import "./submission-fragment.graphql"
#import "./account-fragment.graphql"
#import "./lead-fragment.graphql"
#import "./assignment-fragment.graphql"
#import "./constant-contact-contact-tracking-activity-fragment.graphql"
#import "./entity-attribute-value-file-fragment.graphql"
#import "./comment-banner-fragment.graphql"
#import "./session-fragment.graphql"
#import "./thread-fragment.graphql"
#import "./message-fragment.graphql"
#import "./quote-banner-fragment.graphql"
#import "./quote-view-fragment.graphql"
#import "./invoice-banner-fragment.graphql"
#import "./ma-url-fragment.graphql"

#import "./sparse/email-fragment-sparse.graphql"
#import "./sparse/email-queued-fragment-sparse.graphql"
#import "./sparse/email-interaction-fragment-sparse.graphql"
#import "./sparse/chat-fragment-sparse.graphql"
#import "./sparse/activity-fragment-sparse.graphql"

#import "../../reactions/graphql/fragments/reaction-fragment.graphql"
#import "../../comments/graphql/fragments/comment-fragment.graphql"

fragment EventFragmentSparse on TimelineEvent {
    id
    changeType
    actor {
        ... on User {
            ...UserFragment
        }
        ... on Origin {
            ...OriginFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Account {
            ...AccountFragment
        }
        ... on MaUrl {
            ...MaUrlFragment
        }
    }
    payload {
        ... on Activity {
            ...ActivityFragmentSparse
        }
        ... on AccountRelationshipChange {
            entityAdded {
                ...AccountFragment
            }
            action
        }
        ... on AccountContactFormerStatusChange {
            account {
                ...AccountFragment
            }
            formerStatusContact: contact {
                ...ContactFragment
            }
            formerStatusAction: action
        }
        ... on Note {
            ...NoteFragment
        }
        ... on Email {
            ...EmailFragmentSparse
        }
        ... on EmailQueued {
            ...EmailQueuedFragmentSparse
        }
        ... on Origin {
            ...OriginFragment
        }
        ... on Submission {
            ...SubmissionFragment
        }
        ... on Account {
            ...AccountFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Lead {
            ...LeadFragment
        }
        ... on Chat {
            ...ChatFragmentSparse
        }
        ... on Assignment {
            ...AssignmentFragment
        }
        ... on EmailInteraction {
            ...EmailInteractionFragmentSparse
        }
        ... on ConstantContactContactTrackingActivity {
            ...ConstantContactContactTrackingActivityFragment
        }
        ... on EntityAttributeValueFile {
            ...EntityAttributeValueFileFragment
        }
        ... on Comment {
            ...CommentBannerFragment
        }
        ... on Session {
            ...SessionFragment
        }
        ... on Thread {
            ...ThreadFragment
        }
        ... on Message {
            ...MessageFragment
        }
        ... on Quote {
            ...QuoteBannerFragment
        }
        ... on SalesDocumentView {
            ...QuoteViewFragment
        }
        ... on Invoice {
            ...InvoiceBannerFragment
        }
        ... on LeadClonePayload {
            original {
                ...LeadFragment
            }
            clone {
                ...LeadFragment
            }
        }
    }
    changeTime
    changes {
        id
        attribute
        oldValue
        newValue
    }
    files {
        ...EntityAttributeValueFileFragment
    }
    reactions {
        ...ReactionFragment
    }
    comments {
        ...CommentFragment
    }
    count
}
